var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { title: "editortoolbar" } }, [
    _vm.pageModel
      ? _c(
          "div",
          {
            key: "objectToolbar",
            class: { collapsed: !_vm.showObjectToolbar },
            on: {
              mousedown: function ($event) {
                $event.stopPropagation()
              },
              touchstart: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            _c("ObjectToolbarView", {
              attrs: { "page-model": _vm.pageModel },
              on: {
                hideToolbar: function ($event) {
                  _vm.showObjectToolbar = false
                },
                editText: _vm.editText,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showEditTextToolbar
      ? _c(
          "div",
          {
            key: "editTextToolbar",
            staticClass: "toolbarExtraHigh",
            on: {
              mousedown: function ($event) {
                $event.stopPropagation()
              },
              touchstart: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            _c("EditTextView", {
              attrs: { "close-icon": true, "page-model": _vm.pageModel },
              on: {
                hideToolbar: function ($event) {
                  _vm.showEditTextToolbar = false
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }